(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5879],{

/***/ 39707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ extendSxProp; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63366);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59766);
/* harmony import */ var _getThemeValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85578);


const _excluded = ["sx"];



const splitProps = props => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  Object.keys(props).forEach(prop => {
    if (_getThemeValue__WEBPACK_IMPORTED_MODULE_0__/* .propToStyleFunction */ .Gc[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};

function extendSxProp(props) {
  const {
    sx: inSx
  } = props,
        other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, _excluded);

  const {
    systemProps,
    otherProps
  } = splitProps(other);
  let finalSx;

  if (Array.isArray(inSx)) {
    finalSx = [systemProps, ...inSx];
  } else if (typeof inSx === 'function') {
    finalSx = (...args) => {
      const result = inSx(...args);

      if (!(0,_mui_utils__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .P)(result)) {
        return systemProps;
      }

      return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, result);
    };
  } else {
    finalSx = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, systemProps, inSx);
  }

  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, otherProps, {
    sx: finalSx
  });
}

/***/ }),

/***/ 32699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NumberToggle_NumberToggle; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/elements/inputs/NumberToggle/NumberToggle.module.scss
var NumberToggle_module = __webpack_require__(67730);
var NumberToggle_module_default = /*#__PURE__*/__webpack_require__.n(NumberToggle_module);
;// CONCATENATED MODULE: ./src/components/elements/inputs/NumberToggle/NumberToggle.tsx


var NumberToggle = function(param) {
    var value = param.value, _onChange = param.onChange, onChange = _onChange === void 0 ? function() {} : _onChange, _step = param.step, step = _step === void 0 ? 1 : _step, _minValue = param.minValue, minValue = _minValue === void 0 ? 0 : _minValue, maxValue = param.maxValue, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _increaseDisabled = param.increaseDisabled, increaseDisabled = _increaseDisabled === void 0 ? false : _increaseDisabled;
    // const [value, setValue] = useState<number>(initialValue)
    // useEffect(() => {
    //   setValue(initialValue)
    // }, [initialValue])
    var handleDecrease = function() {
        if (value > minValue) {
            // setValue(value - step)
            onChange(value - step, "decrease");
        }
    };
    var handleIncrease = function() {
        // setValue(value + step)
        onChange(value + step, "increase");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (NumberToggle_module_default()).root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((NumberToggle_module_default()).button, " ").concat(value === minValue || disabled ? (NumberToggle_module_default()).disabled : ""),
                onClick: handleDecrease,
                children: "-"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((NumberToggle_module_default()).value, " ").concat(disabled ? (NumberToggle_module_default()).disabled : ""),
                children: value
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((NumberToggle_module_default()).button, " ").concat(value === maxValue || increaseDisabled || disabled ? (NumberToggle_module_default()).disabled : ""),
                onClick: handleIncrease,
                children: "+"
            })
        ]
    });
};
/* harmony default export */ var NumberToggle_NumberToggle = (NumberToggle);

;// CONCATENATED MODULE: ./src/components/elements/inputs/NumberToggle/index.ts



/***/ }),

/***/ 70894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lK": function() { return /* reexport */ actions/* applyMandatoryBookingAddons */.lK; },
  "Bv": function() { return /* reexport */ actions/* downgradeBookingFromExtensionDate */.Bv; },
  "U_": function() { return /* reexport */ reducer/* getStateBooking */.U_; },
  "ci": function() { return /* reexport */ actions/* initBooking */.ci; },
  "u9": function() { return /* reexport */ actions/* initBookingPayment */.u9; },
  "RM": function() { return /* reexport */ actions/* loadBookingSummary */.RM; },
  "rP": function() { return /* reexport */ actions/* loadContingents */.rP; },
  "Jn": function() { return /* reexport */ actions/* resetBookingState */.Jn; },
  "wY": function() { return /* reexport */ selectBookings; },
  "D7": function() { return /* reexport */ actions/* setAccommodationAddonSelection */.D7; },
  "bL": function() { return /* reexport */ actions/* setAccommodationSelection */.bL; },
  "dk": function() { return /* reexport */ actions/* setBabies */.dk; },
  "QY": function() { return /* reexport */ actions/* setBabyAddress */.QY; },
  "wC": function() { return /* reexport */ actions/* setBillingAddress */.wC; },
  "Mp": function() { return /* reexport */ actions/* setBookingAddonSelection */.Mp; },
  "_9": function() { return /* reexport */ actions/* setBookingCustomData */._9; },
  "NS": function() { return /* reexport */ actions/* setBookingEntryPoint */.NS; },
  "zS": function() { return /* reexport */ actions/* setBookingEsimService */.zS; },
  "Gk": function() { return /* reexport */ actions/* setBookingFatalError */.Gk; },
  "Er": function() { return /* reexport */ actions/* setBusStopSelectionOutbound */.Er; },
  "cO": function() { return /* reexport */ actions/* setBusStopSelectionReturn */.cO; },
  "NH": function() { return /* reexport */ actions/* setCO2Compensation */.NH; },
  "IX": function() { return /* reexport */ actions/* setChildren */.IX; },
  "he": function() { return /* reexport */ actions/* setCollectiveAddonSelection */.he; },
  "VF": function() { return /* reexport */ actions/* setCurrentBookingStep */.VF; },
  "OS": function() { return /* reexport */ actions/* setCustomBookingParams */.OS; },
  "XI": function() { return /* reexport */ actions/* setFamilyInsurance */.XI; },
  "Fo": function() { return /* reexport */ actions/* setFamilyPackage */.Fo; },
  "Rv": function() { return /* reexport */ actions/* setMarketingInformation */.Rv; },
  "$P": function() { return /* reexport */ actions/* setPaymentMethod */.$P; },
  "Rh": function() { return /* reexport */ actions/* setPersonalAddonSelection */.Rh; },
  "eZ": function() { return /* reexport */ actions/* setPersonalDiscountSelection */.eZ; },
  "Tr": function() { return /* reexport */ actions/* setPricingTravelId */.Tr; },
  "DY": function() { return /* reexport */ actions/* setTravelDate */.DY; },
  "so": function() { return /* reexport */ actions/* setTravelDocumentationService */.so; },
  "xI": function() { return /* reexport */ actions/* setTravellerAddress */.xI; },
  "zi": function() { return /* reexport */ actions/* setTravellerInsurance */.zi; },
  "NA": function() { return /* reexport */ actions/* setTravellerRemarks */.NA; },
  "HO": function() { return /* reexport */ actions/* setTravellers */.HO; },
  "xO": function() { return /* reexport */ actions/* submitBooking */.xO; },
  "Pj": function() { return /* reexport */ actions/* switchBookingExtensionDate */.Pj; },
  "q2": function() { return /* reexport */ actions/* toggleWaitlistFallbackAvailabilityStatus */.q2; },
  "VY": function() { return /* reexport */ actions/* upgradeBookingToExtensionDate */.VY; }
});

// UNUSED EXPORTS: bookingReducer, bookingSelector, getStateBookingByPaymentTransactionId, reloadPricingTravel, setBookingLastActivityTimestamp, setBookingRemarks

// EXTERNAL MODULE: ./src/features/booking/actions.ts
var actions = __webpack_require__(87694);
// EXTERNAL MODULE: ./src/features/booking/reducer.ts
var reducer = __webpack_require__(13216);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/features/booking/selectors.ts

var selectBookings = function(state) {
    return state.bookings;
};
var bookingSelector = (0,es/* createSelector */.P1)(selectBookings, function(state) {
    return state;
});

;// CONCATENATED MODULE: ./src/features/booking/index.ts





/***/ }),

/***/ 67730:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"NumberToggle_root__V_ZQy","button":"NumberToggle_button__XYVpU","disabled":"NumberToggle_disabled__u_NAj","value":"NumberToggle_value__b7SXl"};

/***/ }),

/***/ 14331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Placeholder; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/usePlaceholder.js



function usePlaceholder({
  animation,
  bg,
  bsPrefix,
  size,
  ...props
}) {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'placeholder');
  const [{
    className,
    ...colProps
  }] = (0,Col/* useCol */.r)(props);
  return { ...colProps,
    className: classnames_default()(className, animation ? `${bsPrefix}-${animation}` : bsPrefix, size && `${bsPrefix}-${size}`, bg && `bg-${bg}`)
  };
}
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/PlaceholderButton.js




const PlaceholderButton = /*#__PURE__*/react.forwardRef((props, ref) => {
  const placeholderProps = usePlaceholder(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, { ...placeholderProps,
    ref: ref,
    disabled: true,
    tabIndex: -1
  });
});
PlaceholderButton.displayName = 'PlaceholderButton';
/* harmony default export */ var esm_PlaceholderButton = (PlaceholderButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Placeholder.js




const Placeholder = /*#__PURE__*/react.forwardRef(({
  as: Component = 'span',
  ...props
}, ref) => {
  const placeholderProps = usePlaceholder(props);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, { ...placeholderProps,
    ref: ref
  });
});
Placeholder.displayName = 'Placeholder';
/* harmony default export */ var esm_Placeholder = (Object.assign(Placeholder, {
  Button: esm_PlaceholderButton
}));

/***/ })

}]);